import { api } from '../lib/api'
import { requestMeRefresh } from '../hooks/useMe'

export async function uploadAvatar(file: File) {
  const fd = new FormData()
  fd.append('file', file)
  const { data } = await api.post<{ asset_id: number; preview_url: string; status: string }>(
    '/api/uploads/image',
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return data
}

export async function publishAvatar(assetId: number) {
  const { data } = await api.post<{ avatar: any; profile: { avatar_url: string; cache_bust?: number } }>(
    `/api/avatars/${assetId}/publish/`,
    {}
  )
  requestMeRefresh()
  return data
}
